<template>
  <div class="policy">
    <el-main v-if="isPc">
      <el-tabs v-model="active" tab-position="left" @tab-click="tabClick">
        <el-tab-pane label="協會公告" name="0">
          <ul>
            <li
              class="notice_item little_hand"
              v-for="(item, index) in fileListRes2"
              :key="index"
              @click="fnToFileDetails(item.cunpan_id)"
            >
              <div class="title">{{ item.name }}</div>
              <time>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</time>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="服務課表" name="1">
          <el-row :gutter="20" class="course-lists">
            <el-col :span="6" v-for="(item, index) in courseList" :key="index">
              <div
                class="course-lists-item little_hand"
                @click="fnToCourse(item.course_id)"
              >
                <img :src="$imgUrl + item.main_image" />
                <div class="title">
                  <h3>
                    {{ item.course_name }}
                  </h3>
                  <p>
                    {{ item.description }}
                  </p>
                  <time>{{
                    $dayjs(item.create_time).format("YYYY-MM-DD")
                  }}</time>
                  <em v-if="item.current_price > 0">訂閱</em>
                  <em v-else>免费</em>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="服務文章" name="2">
          <div class="service-types">
            <ul >
              <li
                v-for="(item, index) in typeArr"
                :key="item.type"
                :class="{ active: activeType == index }"
                @click="changeServiceType(index)"
              >
                <img :src="item.img" alt="" />
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <ul class="service-lists">
            <li
              class="little_hand"
              v-for="(item, index) in serviceList"
              :key="index"
              @click="fnToArticle(item.article_id)"
            >
              <div>
                <span :style="'background-color:'+item.color">{{ item.type }}</span>
                {{ item.title }}
              </div>
              <time>{{ $dayjs(item.create_time).format("YYYY-MM-DD") }}</time>
            </li>
          </ul>
          <el-button class="btn" type="info" @click="fnToGetMore()"
            >點擊加載更多</el-button
          >
        </el-tab-pane>
        <el-tab-pane label="政策文件" name="3">
          <el-input
            placeholder="請輸入關鍵字"
            v-model="title"
            clearable
            @clear="getFileList(1)"
            autofocus="true"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getFileList(1)"
            ></el-button>
          </el-input>
          <!-- <div class="zc-cont">
            <div class="zc-bqy">
              <div class="zc-title">
                <i> <img src="../assets/images/zcbt-ico01.png" /></i>
                政策分析解讀
                <i> <img src="../assets/images/zcbt-ico02.png" /></i>
              </div>
              <div class="zc-box zc-cyfx">
                <div
                  class="tagcloud cyfx-tagcloud"
                  style="
                    visibility: visible;
                    position: relative;
                    min-height: 192px;
                    min-width: 400px;
                  "
                >
                  <a
                    v-for="(item, index) in hotTag"
                    :key="item.id"
                    :style="`background: ${colorArr[index % 5]};`"
                    @click="changeType(1, item.prolicytype_id, item.type_name)"
                    target="_blank"
                  >
                    {{ item.type_name }}
                  </a>
                </div>
                <a class="more" href="###" target="_blank">更多 &gt;</a>
              </div>
            </div>
            <div class="zc-dtk">
              <div class="zc-title">
                <i> <img src="../assets/images/zcbt-ico01.png" /></i>
                政策咨詢
                <i> <img src="../assets/images/zcbt-ico02.png" /></i>
              </div>
              <div class="zc-box zc-dtzs">
                <el-form ref="form" :model="form" label-width="80px">
                  <el-form-item label="企業名稱">
                    <el-input v-model="form.company_name"></el-input>
                  </el-form-item>
                  <el-form-item label="所屬行業">
                    <el-select
                      v-model="form.industry_id"
                      placeholder="請選擇所屬行業"
                    >
                      <el-option
                        v-for="item in industryRes"
                        :key="item.industry_id"
                        :label="item.industry_name"
                        :value="item.industry_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      class="btn"
                      type="primary"
                      @click="getFileList(1)"
                      >獲取查詢結果</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div> -->

          <div class="file-type" v-if="fileTypeList.length > 0">
            <h3>文件類型:</h3>
            <span
              :class="[{ active: prolicytype_id == '' }, 'little_hand']"
              @click="changeType(1, '')"
              >全部</span
            >
            <span
              :class="[
                { active: prolicytype_id == item.prolicytype_id },
                'little_hand',
              ]"
              v-for="(item, index) in fileTypeList"
              :key="index"
              @click="changeType(1, item.prolicytype_id, item.type_name)"
              >{{ item.type_name }}</span
            >
          </div>
          <div style="clear: both"></div>
          <ul>
            <li
              class="notice_item little_hand"
              v-for="(item, index) in fileListRes1"
              :key="index"
              @click="fnToFileDetails(item.cunpan_id)"
            >
              <div class="title">
                <em v-if="item.current_price > 0">訂閱</em>{{ item.name }}
              </div>
              <time
                >成文日期：{{
                  $dayjs(item.writed_time).format("YYYY-MM-DD")
                }}</time
              >
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <div v-else class="m-tabs">
      <el-tabs v-model="active" tab-position="top" @tab-click="tabClick">
        <el-tab-pane label="協會公告" name="0">
          <ul>
            <li
              class="notice_item little_hand"
              v-for="(item, index) in fileListRes2"
              :key="index"
              @click="fnToFileDetails(item.cunpan_id)"
            >
              <div class="title">{{ item.name }}</div>
              <time>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</time>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="服務課表" name="1">
          <ul>
            <li
              class="little_hand"
              v-for="(item, index) in courseList"
              :key="index"
              @click="fnToCourse(item.course_id)"
            >
              <div class="title">
                <!-- <span v-if="item.type=='CASE'">法律</span>
                <span v-else-if="item.type=='CWZX'">財稅</span>
                <span v-else-if="item.type=='ZXXX'">企管</span>
                <span v-else>健康</span> -->
                <em v-if="item.current_price > 0">訂閱</em>
                {{ item.course_name }}
              </div>
              <time>{{ $dayjs(item.create_time).format("YYYY-MM-DD") }}</time>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="服務文章" name="2">
          <ul>
            <li
              class="little_hand"
              v-for="(item, index) in serviceList"
              :key="index"
              @click="fnToArticle(item.article_id)"
            >
              <div class="s-title">
                <span>{{ item.type }}</span>
                {{ item.title }}
              </div>
              <time>{{ $dayjs(item.create_time).format("YYYY-MM-DD") }}</time>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="政策文件" name="3">
          <div class="file-type" v-if="fileTypeList.length > 0">
            <h3>文件類型:</h3>
            <span
              :class="[{ active: prolicytype_id == '' }, 'little_hand']"
              @click="changeType(1, '')"
              >全部</span
            >
            <span
              :class="[
                { active: prolicytype_id == item.prolicytype_id },
                'little_hand',
              ]"
              v-for="(item, index) in fileTypeList"
              :key="index"
              @click="changeType(1, item.prolicytype_id)"
              >{{ item.type_name }}</span
            >
          </div>
          <div style="clear: both"></div>
          <ul>
            <li
              class="notice_item little_hand"
              v-for="(item, index) in fileListRes1"
              :key="index"
              @click="fnToFileDetails(item.cunpan_id)"
            >
              <div class="title">
                <em v-if="item.current_price > 0">訂閱</em>{{ item.name }}
              </div>
              <time> {{ $dayjs(item.writed_time).format("YYYY-MM-DD") }}</time>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import "../assets/js/tagcloud.js";
import {
  traditionalized,
  simplized,
} from "../assets/js/simplifiedToTraditional.js";

export default {
  data() {
    return {
      active: this.$route.params.active ? this.$route.params.active + "" : "0",
      start: 0,
      limit: 35,
      fileListRes1: [],
      fileListRes2: [],
      serviceStart: 0,
      serviceLimit: 15,
      serviceListRes: [],
      courseList: [],
      prolicytype_id: "",
      fileTypeList: [],
      title: "",
      hotTag: [],
      colorArr: [
        "rgb(247, 237, 217)",
        "rgb(188, 198, 253)",
        "rgb(220, 217, 248)",
        "rgb(221, 245, 237)",
        "rgb(217, 233, 247)",
      ],
      form: {
        company_name: "",
        industry_id: "",
      },
      industryRes: [],
      activeType: 0,
      typeArr: [
        {
          name: "全部",
          img: require("../assets/imgs/service01.png"),
          type: "service",
        },
        {
          name: "企管",
          img: require("../assets/imgs/service02.png"),
          type: "ZXXX",
        },
        {
          name: "法律",
          img: require("../assets/imgs/service03.png"),
          type: "CASE",
        },
        {
          name: "健康",
          img: require("../assets/imgs/service04.png"),
          type: "QTFW",
        },
        {
          name: "財稅",
          img: require("../assets/imgs/service05.png"),
          type: "CWZX",
        },
        {
          name: "品牌",
          img: require("../assets/imgs/service06.png"),
          type: "PPWZ",
        },
        {
          name: "防疫",
          img: require("../assets/imgs/service01.png"),
          type: "FYWZ",
        },
      ],
    };
  },
  computed: {
    ...mapState(["user_id", "validToken", "isPc"]),
    serviceList() {
      return this.serviceListRes.map((item) => {
        if (item.article_type == "QTFW") {
          item.type = "健康";
          item.color = "#1AC659";
        } else if (item.article_type == "ZXXX") {
          item.type = "企管";
          item.color = "#0279FF";
        } else if (item.article_type == "CASE") {
          item.type = "法律";
          item.color = "#C076DB";
        } else if (item.article_type == "CWZX") {
          item.type = "財稅";
          item.color = "#FF3A30";
        } else if (item.article_type == "PPWZ") {
          item.type = "品牌";
          item.color = "#FFCB02";
        } else if (item.article_type == "FYWZ") {
          item.type = "防疫";
          item.color = "#51AAF2";
        } else {
          item.type = "";
        }
        return item;
      });
    },
  },
  watch: {
    title(val) {
      // this.newsListRes = [];
      // this.start = 0;
      // if(!val) return false;
      // this.getNewsList();
    },
    $route(to, from) {
      // console.log(this.$$route)
      // console.log(to)
      // console.log(from)
      this.active = to.params.active;
      this.title = to.query.keyword;
    },
    hotTag(val) {
      if (val)
        setTimeout(() => {
          window.tagcloud({
            selector: ".tagcloud", //元素选择器
            fontsize: 16, //基本字体大小, 单位px
            radius: 80, //滚动半径, 单位px
            mspeed: "normal", //滚动最大速度, 取值: slow, normal(默认), fast
            ispeed: "slow", //滚动初速度, 取值: slow, normal(默认), fast
            direction: 135, //初始滚动方向, 取值角度(顺时针360): 0对应top, 90对应left, 135对应right-bottom(默认)...
            keep: false, //鼠标移出组件后是否继续随鼠标滚动, 取值: false, true(默认) 对应 减速至初速度滚动, 随鼠标滚动
          });
        }, 100);
    },
  },
  mounted() {},
  methods: {
    clickTagItem() {},
    tabClick(e) {
      this.$router.push({
        path: `/policy/${this.active}`,
      });
    },
    async getFileList(type_id, prolicytype_id) {
      const { data: res } = await this.$http.get("/api/v2/cunpan/list", {
        params: {
          start: this.start,
          limit: this.limit,
          searchJson: {
            type: type_id,
            prolicytype_id: prolicytype_id,
            association_id: "SZTX",
            company_name: this.form.company_name,
            industry_id: this.form.industry_id,
            name: this.title ? traditionalized(this.title) : "",
          },
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      if (type_id == 2) {
        this.fileListRes2 = res.data;
      } else {
        this.fileListRes1 = res.data;
      }
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    async getServiceList() {
      const { data: res } = await this.$http.get("/api/v2/article/list", {
        params: {
          start: this.serviceStart,
          limit: this.serviceLimit,
          searchJson: {
            article_type: this.typeArr[this.activeType].type,
            // association_id: "SZTX",
          },
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.serviceListRes = [...this.serviceListRes, ...res.data];
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    changeServiceType(index){
      this.activeType=index;
      this.serviceListRes =[]
      this.serviceStart=0
      this.getServiceList()
    },
    fnToGetMore() {
      this.serviceStart += this.serviceLimit;
      this.getServiceList();
    },
    //服务课程
    async getCourseList() {
      const { data: res } = await this.$http.get("/api/v2/course/list", {
        params: {
          start: 0,
          limit: 100,
          user_id: this.user_id,
          searchJson: {},
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.courseList = res.data;
    },
    fnToCourse(course_id) {
      this.$router.push({
        path: `/course/${course_id}`,
      });
    },
    fnToFileDetails(cunpan_id) {
      this.$router.push({
        path: `/file/${cunpan_id}`,
      });
    },
    fnToArticle(article_id) {
      // console.log(article_id)
      this.$router.push({
        path: `/article/${article_id}`,
      });
    },
    async getFileTypeList() {
      const { data: res } = await this.$http.get("/api/v2/cunpan/prolicyType");
      if (res.code !== "200") return false;
      this.fileTypeList = res.data;
      this.hotTag = this.fileTypeList;
    },
    async getIndustryClassification() {
      const { data: res } = await this.$http.get("/api/v2/company/industry");
      if (res.code !== "200") return false;
      this.industryRes = res.data;
    },
    changeType(type_id, prolicytype_id, type_name) {
      // this.title = type_name;
      this.prolicytype_id = prolicytype_id;
      this.getFileList(type_id, prolicytype_id);
    },
    // 获取查询结果
    fnGetPolicy() {
      // console.log(this.form)
      this.getFileList(1);
    },
  },
  created() {
    //政策文件
    this.getFileList(1);
    //公告
    this.getFileList(2);
    this.getCourseList();

    this.getServiceList();
    this.getFileTypeList(); //政策类型
    this.getIndustryClassification(); //行业分类
    this.title = this.$route.query.keyword;
  },
};
</script>

<style lang="less" scoped>
.el-main {
  width: 1200px;
}
.btn {
  width: 50%;
  margin: 20px auto;
  display: block;
  font-size: 14px !important;
  color: #878787 !important;
  line-height: 22px !important;
  padding: 10px 0 !important;
  background: #ddd !important;
  border: none !important;
}

/deep/.el-tabs__header {
  width: 200px;
  background-color: rgb(244, 244, 244);
  margin-right: 30px !important;
  display: none;
  .el-tabs__nav-wrap::after {
    content: none;
  }
  .el-tabs__item {
    font-size: 18px;
    padding: 8px;
    height: auto;
    font-weight: normal;
    text-align: center !important;
    color: rgb(157, 156, 157);
  }
  .el-tabs__item.is-active {
    color: #ffffff;
    background: #4f4e95;
  }
  .el-tabs__item:hover {
    color: #4f4e95 !important;
  }
  .el-tabs__item.is-active {
    color: #ffffff !important;
  }
  .el-tabs__active-bar {
    background-color: #4f4e95;
  }
}
.el-tab-pane {
  padding: 15px 28px;
  padding-top: 0;
  ul {
    margin-top: 5px;
    li {
      padding: 15px 0;
      display: flex;
      align-items: center;
      /* flex-direction: column; */
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      position: relative;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
        overflow: hidden;
        em {
          background: #f7a724;
          font-size: 14px;
          color: #ffffff;
          padding: 0px 7px;
          border-radius: 4px;
          // width: 20px;
          // height: 20px;
          display: inline-block;
          // background: url(../assets/images/fee.png) no-repeat center center;
          // background-size: contain;
          margin-right: 10px;
        }
      }
      .s-title {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        overflow: hidden;
      }
      span {
        width: fit-content;
        font-size: 14px;
        color: #ffffff;
        padding: 2px 8px;
        border-radius: 20px;
        background: #333;
        margin-left: 8px;
      }
      a {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .list-circle:before {
        content: "";
        width: 6px;
        height: 6px;
        background: #dddddd;
        display: inline-block;
        margin-right: 15px;
        vertical-align: middle;
      }
      time {
        // margin-top: 10px;
        font-size: 14px;
        color: #333333;
        margin-left: 20px;
        font-family: Helvetica Neue;
        min-width: 80px;
      }
    }
  }
}
.file-type {
  h3 {
    font-size: 20px;
    font-weight: bold;
    line-height: 50px;
    // display: inline;
    // float: left;
  }
  span {
    float: left;
    font-size: 16px;
    padding: 5px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid #eeeeee;
    color: #333;
  }
  .active {
    background: #4f4e95;
    color: #ffffff;
  }
}
.m-tabs .el-tab-pane {
  padding: 0 20px;
}
.el-select {
  width: 100%;
}
.policy {
  background: #f2f2f2;
  padding: 50px 0;
}
// 汇课堂
.el-tab-pane {
  padding: 0;
}
.course-lists {
  .course-lists-item {
    background: #ffffff;
    border-radius: 8px;
    padding: 0 !important;
    overflow: hidden;
    margin-bottom: 20px;
    font-size: 0;
    img {
      width: 100%;
      height: 175px;
      border-radius: 4.51px;
      object-fit: cover;
    }
    .title {
      padding: 10px 15px;
      height: 133px;
      box-sizing: border-box;
      h3 {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #222222;
        letter-spacing: 0;
        font-weight: 400;
        margin-bottom: 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      p {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #888888;
        letter-spacing: 0;
        font-weight: 400;
        margin-bottom: 5px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      time {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #888888;
        letter-spacing: 0;
        font-weight: 400;
      }
      em {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #ff3a30;
        letter-spacing: 0;
        font-weight: 400;
        margin-top: 10px;
        display: block;
      }
    }
  }
}
// 专项服务
.service-types {
  background: #ffffff;
  border-radius: 8px;
  padding: 15px 20px;
  ul {
    display: flex;
    align-content: center;
    li {
      border-bottom: none;
      display: flex;
      flex-direction: column;
      align-content: center;
      padding: 0;
      margin-right: 20px;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        padding: 6px;
        background: #f2f2f2;
        border-radius: 40px;
        // box-sizing: border-box;
        margin-bottom: 5px;
        border: 2px solid #f2f2f2;

      }
      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #222222;
        letter-spacing: 0;
        text-align: justify;
        font-weight: 400;
        margin: 0;
        padding: 0;
        border-radius: 0;
        background: transparent;
      }
    }
    .active {
      img {
        border: 2px solid rgba(32, 49, 127, 1);
      }
      span {
        color: #20317f;
      }
    }
  }
}
.service-lists{
  background: #FFFFFF;
border-radius: 8px;
padding: 10px 20px;
ul{
  padding: 15px 0;
}
}
</style>
